import api, { ResponseCallback } from '../services/api.service'
import routeUtil from '../utils/route.util'
import { ContactSiteData } from './contactSite.api'
import { CustomerData } from './customer.api'
import { SiteData } from './site.api'
import { UserData } from './user.api'

type LicensePlateApplicable = SiteData | CustomerData | ContactSiteData

export type LicensePlateApplicableType = 'site' | 'customer' | 'customerSite'

export interface LicensePlateData {
  id: number
  siteId: number
  applicableId: number
  createdBy: number
  updatedBy: number
  deletedBy?: number
  applicableType: LicensePlateApplicableType
  createdAt: string
  updatedAt: string
  deletedAt?: string
  isDeleted: boolean
  applicable?: LicensePlateApplicable
  createdUser?: UserData
  updatedUser?: UserData
}

export interface LicensePlateCreateRequest {
  customer?: number
  customerSite?: number
  licensePlates?: File | null
}

const routes = {
  list: '/licensePlates',
  download: '/licensePlates/{id}/download',
  delete: '/licensePlates/{id}',
  create: '/licensePlates'
}

export default {
  list (callback: ResponseCallback<LicensePlateData[]>) {
    api.get(routes.list, {}, callback)
  },

  download (id: number, callback: ResponseCallback<Blob>) {
    const url = routeUtil.replaceParams(routes.download, { id })
    api.get(url, {}, callback)
  },

  delete (id: number, callback: ResponseCallback<LicensePlateData>) {
    const url = routeUtil.replaceParams(routes.delete, { id })
    api.delete(url, {}, callback)
  },

  create (
    payload: LicensePlateCreateRequest,
    callback: ResponseCallback<LicensePlateData>
  ) {
    api.postForm(routes.list, payload, callback)
  }
}
